import { Spinner } from "react-bootstrap";

const Splash = () => {
  return (
    <div
      style={{
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        position: "absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Spinner animation="border" variant="secondary" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default Splash;
